// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"5e0c017d","361":"b78eeaa1"}[chunkId] + ".chunk.js";
};